import { Controller } from '@hotwired/stimulus'

export default class SubscriptionsFilterController extends Controller {
  connect() {
    this.debounceTimer = null;
  }

  submitImmediately() {
    this.element.requestSubmit();
  }

  submitWithDebounce(event) {
    const value = event.target.value;
    if (value.length >= 2 || value.length === 0) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.element.requestSubmit(), 500);
    }
  }

  disconnect() {
    clearTimeout(this.debounceTimer);
  }
}
